'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
require('../../extends-733dd656.js');
var index = require('../../index-7124f64c.js');
require('../../extends-5ede7877.js');
require('../../polished.esm-8ddeb0a5.js');
var colorBuilder = require('../../colorBuilder-8c1a81a8.js');

var colorVariantsShape = index.propTypes.oneOf(colorBuilder.colorVariants);

exports.default = colorVariantsShape;
//# sourceMappingURL=colorVariantsShape.js.map
